module.exports = __webpack_public_path__ + "static/img/boron-3.58de360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/boron-3.jpg
// module id = Ekq8
// module chunks = 1